document.addEventListener('DOMContentLoaded', () => {
  const config = {
    cartSections: ['cart-icon-bubble', 'cart-notification', 'cart-items', 'cart-footer'],
    cartDrawer: document.getElementById('cart-drawer'),
    variantButtons: document.querySelectorAll('.variant-button input[type="radio"]'),
    priceDisplay: document.getElementById('product-price'),
    addToCartButton: document.getElementById('add-to-cart-btn'),
  };

  const cartItemsContainer = config.cartDrawer.querySelector('#cart-drawer-contents .space--drawer-sides');
  const cartFooterContainer = config.cartDrawer.querySelector('.drawer__sticky-footer');

  let addonVariantId = null; // Store the variant ID for the add-on product

  const updateVariantSelection = (selectedVariant) => {
    if (selectedVariant) {
      config.variantButtons.forEach((btn) => btn.closest('.variant-button').classList.remove('selected'));
      selectedVariant.closest('.variant-button').classList.add('selected');
      selectedVariant.checked = true; // Ensure the variant is checked
      config.priceDisplay.textContent = selectedVariant.getAttribute('data-price');
      console.log(`Selected variant ID: ${selectedVariant.value}`);
    }
  };

  const updateCartSections = async () => {
    const response = await fetch('/cart?sections=cart-icon-bubble,cart-notification,cart-items,cart-footer');
    const sections = await response.json();
    config.cartSections.forEach((section) => {
      document.querySelector(`#${section}`).innerHTML = sections[section];
    });
    config.cartDrawer.classList.add('active');
  };

  const showTemporaryMessage = (message, duration) => {
    const messageBox = document.createElement('div');
    messageBox.classList.add('cart-message');
    messageBox.textContent = message;
    Object.assign(messageBox.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#28a745',
      color: '#fff',
      padding: '15px',
      borderRadius: '5px',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      zIndex: '9999',
      opacity: '1',
      transition: 'opacity 0.5s ease',
    });
    document.body.appendChild(messageBox);
    setTimeout(() => {
      messageBox.style.opacity = '0';
      setTimeout(() => messageBox.remove(), 500);
    }, duration);
  };

  const getVariantId = async (productHandle) => {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error(`Product ${productHandle} not found.`);
      const product = await response.json();
      const variant = product.variants[1] || product.variants[0]; // Default to second variant
      console.log(`Fetched variant ID: ${variant.id} for product: ${productHandle}`);
      return variant.id;
    } catch (error) {
      console.error('Error getting variant ID:', error);
      return null;
    }
  };

  const handleAddToCart = async () => {
    try {
      const selectedVariant = document.querySelector('.variant-button input[type="radio"]:checked');
      if (!selectedVariant) return;

      // Add the main product to the cart
      const variantResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: selectedVariant.value, quantity: 1 }),
      });

      if (!variantResponse.ok) throw new Error('Failed to add selected variant.');

      // Add the add-on product to the cart if selected
      if (addonVariantId) {
        const addonResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: addonVariantId, quantity: 1 }),
        });

        if (!addonResponse.ok) throw new Error('Failed to add add-on product.');
        console.log('Add-on product added to cart.');
      }

      // Refresh the cart sections to reflect the changes
      await updateCartSections();


      //showTemporaryMessage('Items added to cart!', 2000);
    } catch (error) {
      console.error('Error adding to cart:', error);
      showTemporaryMessage('Failed to add items to cart. Please try again.', 2000);
    }
  };

  const addonCheckboxes = document.querySelectorAll('.addon-checkboxes input[type="checkbox"]');
  addonCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', async (event) => {
      const productHandle = event.target.value;
      addonVariantId = event.target.checked ? await getVariantId(productHandle) : null;
      if (addonVariantId) console.log(`Selected Add-On Variant ID: ${addonVariantId}`);
    });
  });

  const variantPickers = document.querySelectorAll('.variant-picker');

  variantPickers.forEach(variantPicker => {
    const variantOptions = variantPicker.querySelectorAll('.variant-option');

    if (variantOptions.length >= 2) {
      variantOptions[1].click();
    }
  });

  config.variantButtons.forEach((button) =>
    button.addEventListener('change', () => updateVariantSelection(button))
  );

  config.addToCartButton.addEventListener('click', handleAddToCart);

  document.addEventListener('touchmove', (event) => {}, { passive: true });

});
